var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { globalLoaderHandlers, useLoaderSubscribe } from 'ziphy-web-shared/basic/utils';
import { $notes } from '../../Notes.store';
import UnlockModal from '../unlockModal/Unlock.modal';
const UnlockButton = () => {
    var _a, _b;
    const { t } = useTranslation();
    const [timeLeft, setTimeLeft] = useState(null);
    useEffect(() => {
        var _a;
        if (!$notes.isLocked && ((_a = $notes.unlocked) === null || _a === void 0 ? void 0 : _a.lockCountdown)) {
            setTimeLeft($notes.unlocked.lockCountdown);
        }
        if ($notes.isLocked) {
            setTimeLeft(null);
        }
    }, [$notes.isLocked, (_a = $notes.unlocked) === null || _a === void 0 ? void 0 : _a.lockCountdown, (_b = $notes.unlocked) === null || _b === void 0 ? void 0 : _b.unlockedAt]);
    useEffect(() => {
        if (timeLeft === null) {
            return;
        }
        // after timeout end we wait 15 more seconds before the notes lock invalidation run
        if (timeLeft <= -15) {
            $notes.invalidateLock();
            return;
        }
        const timer = setInterval(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
    }, [timeLeft]);
    useLoaderSubscribe(globalLoaderHandlers.EVENT, ({ eventTypes, events }) => __awaiter(void 0, void 0, void 0, function* () {
        if (eventTypes.has('notes_locked') &&
            events.some((x) => x.encounterId === $notes.encounter.id)) {
            yield $notes.invalidateLock();
        }
    }));
    return (_jsx(_Fragment, { children: $notes.isLocked ? (_jsx(Button, Object.assign({ mode: ['secondary', 'sm'], onClick: () => $modal.add(UnlockModal) }, { children: t('btn.unlock') }))) : (_jsx(Button, Object.assign({ mode: ['secondary', 'sm'], onClick: () => __awaiter(void 0, void 0, void 0, function* () { return yield $notes.lock(); }), isLoading: $notes.isLocking || timeLeft <= 0 }, { children: t('btn.lock_notes') }))) }));
};
export default observer(UnlockButton);
